import React from "react";
import "./CTASection.css";

interface CTA {
  text: string;
  link: string;
}

interface CTASectionProps {
  id?: string;
  title: string;
  description: string;
  cta?: CTA;
  variant?: string;
}

export const CTASection: React.FC<CTASectionProps> = ({
  id,
  title,
  description,
  cta,
  variant,
}) => {
  return (
    <section className={`cta-section ${variant || ""}`} id={id}>
      <div className="cta-inner">
        <div className="cta-copy">
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        {cta && (
          <a href={cta.link} className="cta-button">
            {cta.text}
          </a>
        )}
      </div>
    </section>
  );
};

export default CTASection;
